module.exports = __webpack_public_path__ + "static/media/whichThinnerRecommended.9d8251aa.mp3";